import { TextOverflowTooltip } from '@ipfabric/ui-components/Tooltip/TextOverflowTooltip';
import classNames from 'classnames';
import type {
  SecuritySchemaNodeComponentProps,
  TrivialTestNode,
} from 'components/SecuritySchema/model/SecuritySchemaNode';
import { renderTestNodeMetaInfo } from 'components/SecuritySchema/nodeComponents/renderTestNodeMetaInfo';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';

export const CTrivialTestNode: FC<
  SecuritySchemaNodeComponentProps<TrivialTestNode>
> = ({ node, context }) => {
  const msg = useLocale();
  const msgTest = msg.securitySchema.test;
  return (
    <div
      className={classNames(
        'security-tree-node security-tree-node--test-leaf',
        context.highlightedSubtree && 'security-tree-node--highlighted',
      )}
    >
      {renderTestNodeMetaInfo(node, msg)}
      <TextOverflowTooltip as='p' className='security-tree-node__heading'>
        {node.original || msgTest.simple.operator[node.operator]}
      </TextOverflowTooltip>
    </div>
  );
};
